import { render, staticRenderFns } from "./ActorDetailOPGeneral.vue?vue&type=template&id=4e7b4fd8&"
import script from "./ActorDetailOPGeneral.vue?vue&type=script&lang=js&"
export * from "./ActorDetailOPGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports